
import UiButton from 'JS/components/UiButton.vue';
import Vue, { PropType } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { IProductDetailProductJson } from 'JS/types/PDP';

@Component({
	components: { UiButton },
	name: 'FitmentCTA',
})
class FitmentCTA extends Vue {
	@Prop({ type: Object as PropType<IProductDetailProductJson>, required: true })
	product: IProductDetailProductJson;

	get isBattery() {
		return this.product?.isAutomotiveBattery;
	}

	get productFits(): boolean {
		return this.product.vehicleFitment?.fits;
	}

	get info() {
		if (!this.product.vehicleFitment?.vehicleName) {
			if (this.product.isTire) {
				return {
					title: 'Are you sure it fits?',
					buttonText: 'Add Your Vehicle',
					buttonAction: 'click:addvehicle'
				};
			} else if (this.product.isAutomotiveBattery) {
				return {
					title: 'Are you sure it fits?',
					buttonText: 'Add Your Vehicle',
					buttonLink: '/batteries/',
				};
			} else {
				return {
					title: 'Are you sure it fits?',
					buttonText: 'Add Your Vehicle',
					buttonLink: '/auto-parts/',
				};
			}
		}

		return null;
	}
}

export default FitmentCTA;
